export default __webpack_public_path__ + "static/media/Vannamei shrimp feed 3.1977eb85.jpg";